export function keyBy(arr, key) {
    let obj = {};
    arr.forEach(element => {
        obj[element[key]] = element;
    });
    return obj;
}

//https://stackoverflow.com/a/28855003/9007975
/**
 * Return the intersection of two or more arrays
 * @function
 * @static
 * @param {...*} arrays Arrays to be intersected with.
 * **/
export function intersect(...arrays) {
    // Calculate intersection of multiple array or object values.
    var arrLength = Object.keys(arrays).length;
    // (Also accepts regular objects as input)
    var index = {};
    for (var i in arrays) {
        for (var j in arrays[i]) {
            var v = arrays[i][j];
            if (index[v] === undefined) index[v] = {};
            index[v][i] = true; // Mark as present in i input.
        };
    };
    var retv = [];
    for (var i in index) {
        if (Object.keys(index[i]).length == arrLength) retv.push(i);
    };
    return retv;
}

export function leftJoin(left, ...rights) {
    let index = {};
    for (let key in left) {
        index[left[key]] = true;
    }

    for (let right in rights) {
        for (let key in right) {
            delete index[key];
        }
    }

    return Object.keys(index);
}
